import { TooltipContentProps } from 'recharts'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { ComboChartBarDatum } from './types'

interface ToolTipProps {
  data: ComboChartBarDatum[]
  setTooltipIndex: (tooltipIndex?: number) => void
  tooltipProps: TooltipContentProps<string, number>
  tooltipContent: (props: TooltipContentProps<string, number>) => React.JSX.Element
}

const CustomTooltip = ({ data, tooltipProps, setTooltipIndex, tooltipContent }: ToolTipProps) => {
  useUnsafeEffect(() => {
    if (tooltipProps.label && tooltipProps.active && tooltipProps.payload.length > 0) {
      const index = data.findIndex((obj: { x: string }) => obj?.x === tooltipProps.label)
      setTooltipIndex(index)
    }
    return () => setTooltipIndex(undefined)
  })

  if (!tooltipProps.active) return null
  if (tooltipProps.payload.length === 0) return null

  return tooltipContent(tooltipProps)
}

export { CustomTooltip }
